export default (state = {}) => {
  return state;
};
